import React from 'react'
import { Box, Stack, Fade, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import LazyLoad from 'react-lazyload'
import VideoModalPlayButton from '../VideoModalPlayButton'
interface IBlock2Col {
  image: string
  title?: string
  subtitle?: string
  iconImage?: string
  description?: string[]
  inverted?: boolean
  videoURL?: string
  children?: React.ReactNode
  bgColor?: string
  titleColor?: string
  color?: string
  cs?: boolean
  square?: boolean
  'data-cy'?: string
  dataGTM?: string
}

function styles(props: IBlock2Col) {
  return {
    container: {
      bgcolor: props.cs ? '#eee' : (props.bgColor ?? '#222'),
      borderRadius: props.square ? 0 : 3,
      overflow: 'hidden',
      flexDirection: { xs: 'column', lg: props.inverted == true ? 'row-reverse' : 'row' }
    },
    imgContainer: {
      display: 'flex',
      flexBasis: { xs: '100%', md: '50%' },
      alignItems: 'center',
      aspectRatio: '16/9',
      position: 'relative'
    },
    img: {
      height: '100%',
      width: '100%',
      objectFit: 'cover'
    },
    textContainer: {
      py: { xs: 2, s: 3, sm: 6, md: 8 },
      px: { xs: 2, s: 3, sm: 6, md: 8 },
      flexBasis: '50%',
      textAlign: 'left',
      gap: 2,
      alignItems: 'flex-start',
      justifyContent: 'center'
    },
    iconImage: {
      height: { xs: 12, sm: 14 }
    },
    title: {
      color: props.cs ? '#222' : (props.titleColor ?? '#fff'),
      fontWeight: 700,
      mb: 1
    },
    subtitle: {
      fontSize: '1.1rem',
      color: props.cs ? '#222' : (props.titleColor ?? '#fff'),
      fontWeight: 600
    },
    description: {
      fontSize: '1.1rem',
      color: props.cs ? '#444' : (props.color ?? '#bbb')
    },
    children: {
      flexDirection: 'row',
      gap: 2,
      mt: 1,
      flexWrap: 'wrap'
    }
  }
}

const Block2Col = (props: IBlock2Col) => {
  const { container, imgContainer, img, textContainer, iconImage, title, subtitle, description, children } =
    styles(props)
  return (
    <LazyLoad height={600} offset={200}>
      <Fade in={true} timeout={1000}>
        <Stack sx={{ ...container }} data-cy={props['data-cy']}>
          <Box sx={{ ...imgContainer }}>
            <Box component='img' sx={{ ...img }} src={props.image} title={'title'} />
            {props.videoURL && <VideoModalPlayButton videoURL={props.videoURL} />}
          </Box>
          <Stack data-gtm-click-subsection1={props.dataGTM} data-gtm-component='card' sx={{ ...textContainer }}>
            {props.iconImage && <Box component='img' sx={{ ...iconImage }} src={props.iconImage} />}
            {props.title && (
              <Typography component='h2' variant='h2' sx={{ ...title }}>
                <FormattedMessage id={props.title} />
              </Typography>
            )}
            {props.subtitle && (
              <Typography component='h3' sx={{ ...subtitle }}>
                <FormattedMessage id={props.subtitle} />
              </Typography>
            )}
            {props.description &&
              props.description.map((item: string, index: number) => (
                <Typography sx={{ ...description }} key={index}>
                  <FormattedMessage id={item} />
                </Typography>
              ))}
            {props.children && <Stack sx={{ ...children }}>{props.children}</Stack>}
          </Stack>
        </Stack>
      </Fade>
    </LazyLoad>
  )
}
export default Block2Col
